export default "Smag på jægerstenalderen! Prøv en nem og lækker smagsprøve på fisk tilberedt over bål.";